export default __webpack_public_path__ + "static/media/data.f46fd17a.svg";